import { db } from '$db/local/db';
import { getActiveUserId } from '$core/identity/active-user';
import { nowIso } from '../repositories/common';

/**
 * Recovery pass. Se ejecuta al arrancar el motor de sync.
 * Las ops en 'syncing' quedan huérfanas si el cliente crasheó entre
 * "servidor aplicó" y "cliente borra". Las reponemos a 'pending' para
 * que se reintenten con la misma idempotencyKey (el servidor deduplica).
 */
export async function recoverSyncingOps(): Promise<number> {
  const userId = getActiveUserId();
  const rows = await db.outbox.where('userId').equals(userId).toArray();
  const syncing = rows.filter((o) => o.status === 'syncing');
  if (syncing.length === 0) return 0;

  const now = nowIso();
  await db.transaction('rw', db.outbox, async () => {
    for (const op of syncing) {
      await db.outbox.update(op.id, { status: 'pending', updatedAt: now });
    }
  });

  return syncing.length;
}